export type DashCard = {
	title: string
	unit: string
	mainResult: number
	priority: number
	compResult: number
	comparisonType: ComparisonType
}

export enum ComparisonType {
	NO_COMPARISON = 'NO_COMPARISON',
	PERCENTAGE_CHANGE_COMPARISON = 'PERCENTAGE_CHANGE_COMPARISON',
	PERCENTAGE_COMPARISON = 'PERCENTAGE_COMPARISON',
	ABSOLUTE_CHANGE_COMPARISON = 'ABSOLUTE_CHANGE_COMPARISON',
	ABSOLUTE_COMPARISON = 'ABSOLUTE_COMPARISON'
}
